import type { JSX, SVGProps } from "react";

/** Phosphor Amazon mark: trim left padding (min x ~38); min-y pulled up vs 54 so the ring top isn’t clipped, height kept tight so scaling matches other icons. */
const AMAZON_MARK_VIEWBOX = "38 40 190 192";

export function AmazonIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
    return (
        <svg fill="none" height="17" viewBox="0 0 75 17" width="75" xmlns="http://www.w3.org/2000/svg" {...props}>
            <svg height="17" preserveAspectRatio="xMinYMid meet" viewBox={AMAZON_MARK_VIEWBOX} width="18" x="0" y="0">
                <path
                    d="M248,168v32a8,8,0,0,1-16,0V187.31l-2.21,2.22C226.69,192.9,189.44,232,128,232c-62.84,0-100.38-40.91-101.95-42.65A8,8,0,0,1,38,178.65C38.27,179,72.5,216,128,216s89.73-37,90.07-37.36a3.85,3.85,0,0,1,.27-.3l2.35-2.34H208a8,8,0,0,1,0-16h32A8,8,0,0,1,248,168ZM160,94.53V84A36,36,0,0,0,91.92,67.64a8,8,0,0,1-14.25-7.28A52,52,0,0,1,176,84v92a8,8,0,0,1-16,0v-6.53a52,52,0,1,1,0-74.94ZM160,132a36,36,0,1,0-36,36A36,36,0,0,0,160,132Z"
                    fill="#FFFFFF"
                />
            </svg>
            <text
                dominantBaseline="alphabetic"
                fill="#FFFFFF"
                fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
                fontSize="13"
                fontWeight="600"
                letterSpacing="-0.02em"
                x="17.5"
                y="13.25"
            >
                Amazon
            </text>
        </svg>
    );
}
